import React, { useState } from 'react';
import { Stack } from '@mui/material';
import NavigationItem from './NavigationItem';
import { PaperBox } from './style';
import { MainHeading } from '../../../style/GlobalStyles';

function Navigator({ selectNavigationItem, setSelectNavigationItem, selectedItemDetails, navigationList, drawerOpen }) {
    const [expandedItemId, setExpandedItemId] = useState(selectedItemDetails.selectedNavId);
    
    return (
        <PaperBox component={'div'}>
            <MainHeading variant="heading2" mb={'1.25rem'}>
                Business Navigator
            </MainHeading>

            <Stack
                spacing={2}
                component={'ul'}
                sx={{
                    listStyleType: 'none',

                    mt: '1.25rem',
                }}
            >
                {navigationList?.map((item) => (
                    <NavigationItem
                        key={item.id}
                        item={item}
                        expandedItemId={expandedItemId}
                        setExpandedItemId={setExpandedItemId}
                        setSelectedItem={setSelectNavigationItem}
                        selectedItem={selectNavigationItem}
                        selectedItemDetails={selectedItemDetails}
                        drawerOpen={drawerOpen}
                    />
                ))}
            </Stack>
        </PaperBox>
    );
}

export default Navigator;
